import { Turbo } from "@hotwired/turbo-rails"

// Custom <turbo-stream action="set_attribute" target="…" attribute="…" value="…">
// Updates a single attribute on the target element(s). Useful for pushing a
// fresh value into a Stimulus *Value attribute so the controller picks up the
// change (and, transitively, so user_preferences-bound values flow through to
// localStorage).
Turbo.StreamActions.set_attribute = function () {
  const name = this.getAttribute("attribute")
  if (!name) return

  const value = this.getAttribute("value") ?? ""

  this.targetElements.forEach((target) => target.setAttribute(name, value))
}
